// Status labels (Vietnamese) + MUI colors for internal invoice + HDDT lifecycle (FINV-02-S07).

export const invoiceStatusTranslations = {
  DRAFT: 'Nháp',
  SENT: 'Đã gửi',
  PAID: 'Đã thanh toán',
  HDDT_CREATED: 'HDDT',
  CANCELLED: 'Đã hủy',
  REFUNDED: 'Hoàn tiền',
};

export const getInvoiceStatusColor = (status) => ({
  DRAFT: 'default',
  SENT: 'info',
  PAID: 'success',
  HDDT_CREATED: 'primary',
  CANCELLED: 'error',
  REFUNDED: 'warning',
}[status] || 'default');

export const hddtStatusTranslations = {
  draft: 'Nháp (chờ ký)',
  signed: 'Đã ký',
  cancelled: 'Đã hủy',
  replaced: 'Đã thay thế',
  adjusted: 'Đã điều chỉnh',
};

export const getHddtStatusColor = (status) => ({
  draft: 'default',
  signed: 'success',
  cancelled: 'error',
  replaced: 'warning',
  adjusted: 'info',
}[status] || 'default');
